module.exports = __webpack_public_path__ + "static/media/ceuemar-partitura.43164bef.png";